import AboutDesign from './AboutDesign.vue';

export { AboutDesign };
export default AboutDesign;
